import {
  GET_COMMISSION_HISTORIES,
  ADD_COMMISSION_HISTORY,
  EDIT_COMMISSION_HISTORY,
  ADD_COMMISSION_BULLETIN,
  DELETE_COMMISSION_HISTORY,
  COMMISSION_HISTORIES_LOADING,
  CLEAR_COMMISSION_HISTORIES
} from '../types';
import { IAction, ICommission_history } from '../../types/interfaces';

const initialState = {
  commission_histories: [],
  loading: false
};

interface IState {
  commission_histories: ICommission_history[];
}

export default function(state: IState = initialState, action: IAction) {
  switch (action.type) {
    case GET_COMMISSION_HISTORIES:
      return {
        ...state,
        commission_histories: action.payload,
        loading: false
      };
    case COMMISSION_HISTORIES_LOADING:
      return {
        ...state,
        loading: true
      };
    case CLEAR_COMMISSION_HISTORIES:
      return {
        ...state,
        commission_histories: []
      };
    // case DELETE_COMMISSION_HISTORY:
    //   return {
    //     ...state,
    //     commission_histories: state.commission_histories.filter(commission_history => commission_history.lineIndex !== action.payload)
    //   };
    case ADD_COMMISSION_HISTORY:
      return {
        ...state,
        commission_histories: [...state.commission_histories, action.payload]
      };
    case EDIT_COMMISSION_HISTORY:
      return {
        ...state,
        commission_histories: state.commission_histories.map(e => action.payload.find(t => t.id === e.id) ? action.payload.find(t => t.id === e.id) : e)
        // commission_histories: state.commission_histories.map(e => e.id == action.payload.id ? action.payload : e)
      };
    case ADD_COMMISSION_BULLETIN:
      return {
        ...state,
        commission_histories: state.commission_histories.map(e => action.payload?.commission_histories?.find(t => t.id === e.id) ? action.payload.commission_histories.find(t => t.id === e.id) : e)
      };
    default:
      return state;
  }
}
